(function Module() {
	'use strict';

	mySynch.factory('selectedFarmService', [
		'$rootScope',
		function selectedFarmService($rootScope) {
			return {
				selectedFarm: {},

				setCurrentFarm: function setCurrentFarm(currentFarm) {
					this.selectedFarm = currentFarm;
					$rootScope.$broadcast('farm:changed');
				},

				getCurrentFarm: function getCurrentFarm() {
					return this.selectedFarm;
				}
			};
		}
	]);
})();
